// extracted by mini-css-extract-plugin
module.exports = {"actions":"LoginSuccessPrompt_actions__3n8mD"};